export default __webpack_public_path__ + "5d59304dbe894b83245552b2bfce1a06.png";